export default "__VITE_ASSET__BM7kjr5L__";